import { RouterState } from "connected-react-router";

import { AppState } from "./app.state";

export const getRouterState = (state: AppState): RouterState => state.router;
export const getCurrentLocation = (state: AppState) => getRouterState(state).location;
export const getCurrentPathname = (state: AppState) => getRouterState(state).location.pathname;
